import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../Styles/BlogDetails.css";

const BLOGS_URL =
  "https://raw.githubusercontent.com/DhotradSunnyDentalandOrthodonticClinics/website-blogs/main/blogs.json";

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetch(BLOGS_URL)
      .then((res) => res.json())
      .then((data) => {
        const found = data.find((b) => b.id === Number(id));
        setBlog(found);
      });
  }, [id]);

  if (!blog) return <h2>Blog not found</h2>;

  return (
    <section className="blog-details">
      <h1>{blog.title}</h1>
      <p className="blog-author">~ {blog.author}</p>

      <img src={blog.image} alt={blog.title} />

      {/* 🔥 FORMATTED CONTENT */}
      <div
        className="blog-full-content"
        dangerouslySetInnerHTML={{ __html: blog.fullContent }}
      />
    </section>
  );
};

export default BlogDetails;
